<template>
    <div v-if="permissionsShow" style="display: inline-block;">
        <slot name="havePermission"></slot>
    </div>
    <div v-else style="display: inline-block;">
        <slot name="noPermission"></slot>
    </div>
</template>
<script>
export default {
    props: {
        /* 所有权限信息 */
        permissions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 角色信息 */
        roles: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 权限之一 */
        oneOfPermissions: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },
    data() {
        return {
            solt: '',
            /* 是否满足显示权限 */
            permissionsShow: true
        };
    },
    created() {
        /* 权限数据处理 */
        if (this.permissions.length > 0 || this.oneOfPermissions.length > 0 || this.roles.length > 0) {
            this.permissionsShow = this.dealPermissions(this.permissions, this.roles, this.oneOfPermissions);
            this.$emit('getPermissionsStatus', this.permissionsShow);
        }
    },

    // 实时监听父组件的值
    watch: {
        permissions: {
            handler: function(val) {
                this._permissionChange(val);
            },
            // immediate表示在watch中首次绑定的时候，是否执行handler，值为true则表示在watch中声明的时候，就立即执行handler方法，
            // 值为false，则和一般使用watch一样，在数据发生变化的时候才执行handler。
            immediate: true
        }
    },
    methods: {
        _permissionChange(val) {
            /* 权限数据处理 */
            if (val.length > 0 || this.oneOfPermissions.length > 0 || this.roles.length > 0) {
                this.permissionsShow = this.dealPermissions(val, this.roles, this.oneOfPermissions);
                this.$emit('getPermissionsStatus', this.permissionsShow);
            }
        }
    }
};
</script>
